import { render, staticRenderFns } from "./howToUse.vue?vue&type=template&id=7afa51c0&scoped=true"
import script from "./howToUse.vue?vue&type=script&lang=ts"
export * from "./howToUse.vue?vue&type=script&lang=ts"
import style0 from "./howToUse.vue?vue&type=style&index=0&id=7afa51c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa51c0",
  null
  
)

export default component.exports